import { Button, Checkbox, Form, Input, Typography } from 'antd';
import BackgroundLogoSVG from 'assets/imgs/svg/affiliatePartner/logo.svg';
import styled, { css } from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

// px转换vw
export function vw(pxValue) {
  return pxValue * 1 + 'rem';
}

export const Circle = styled.div`
  padding: 4px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  background: #0063db;
  border-radius: 50%;
  color: #fff;
`;

export const InstructionDash = styled.div`
  display: grid;
  place-items: center;
`;

export const InstructionContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 44px 1fr 44px 1fr;
  align-items: center;
  ${flexGap('var(--step-16px)')}
  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`;

export const CircleContainer = styled.div`
  display: flex;
  align-items: center;
  ${flexGap('8px')}
  padding: var(--step-16px);
  align-self: center;
  position: relative;
  height: clamp(100px, 10vw, 162px);
  background: #eff6fa;
  border-radius: 8px;
`;

export const MainContainer = styled.section`
  --step-0: clamp(12rem, calc(10.4rem + 0.5vw), 18rem);
  --step-16px: clamp(8rem, calc(-0.01rem + 1.3vw), 16rem);
  --main-bg-color: #e5e5e5;
  --form-bg-color: #ffffff;
  --primary-color: #0063db;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--main-bg-color);
  width: 100%;
`;
export const MainForm = styled(Form)`
  --space: clamp(12rem, calc(-16.48rem + 8.92vw), 160rem);
  --font-size: clamp(12rem, calc(10.88rem + 0.38vw), 18rem);
  background-color: var(--form-bg-color);
  width: clamp(280px, 90%, 1200px);
  padding: ${vw(110)} var(--space);
`;

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  width: 100%;
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: rgba(0, 0, 0, 0.2);
  }

  .ant-checkbox .ant-checkbox-inner {
    border-radius: 4px;
    border: 1.5px solid rgba(0, 0, 0, 0.2);
  }

  .ant-checkbox-wrapper {
    margin: 0;
  }

  .ant-checkbox-input:focus,
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: transparent;
    border-color: transparent;
  }

  .ant-checkbox.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-disabled {
    border-color: transparent !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner:after {
    border-color: var(--primary-color);
  }

  .ant-checkbox-checked:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    border: 1px solid palevioletred;
    content: '';
    -webkit-animation: antCheckboxEffect 0.36s ease-in-out;
    animation: antCheckboxEffect 0.36s ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    visibility: hidden;
  }
`;

export const StyledInputGroup = styled(Input.Group)`
  .ant-input {
    padding: 1em;
    background: rgba(7, 19, 33, 0.08);
    border-radius: 0.5em;
  }
  input::placeholder {
    font-style: normal;
    font-weight: 500;
    font-size: 1.125em;
    line-height: 1.375em;
    color: rgba(13, 17, 35, 0.48);
  }

  .ant-form-item-label {
    display: flex;
    place-items: center;
  }
`;

export const StyledButton = styled(Button)`
  background-repeat: no-repeat;
  background-position: right;
  background-image: url(${BackgroundLogoSVG}),
    linear-gradient(94.57deg, var(--primary-color) 0%, #17c7ff 100%); /* W3C */
  border-radius: 8px;
  width: 100%;
  min-height: 45px;
`;

const propsCss = css`
  color: ${(props) => props.color && `${props.color} !important`};
  font-size: ${(props) => (props.fontSize ? props.fontSize : 'var(--step-0)')} !important;
  ${(props) => (props.fontWeight ? `font-weight:${props.fontWeight} !important` : undefined)};
`;

export const TitleTypography = styled(Typography.Title)`
  ${propsCss}
  margin: 0 !important;
`;

export const TextTypography = styled(Typography.Text)`
  ${propsCss}
`;

export const Center = styled.div`
  display: grid;
  place-items: center;
`;
